// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__278oH","fileDisabled":"File_fileDisabled__KXEcv"};